export default "__VITE_ASSET__BCxRQ7af__"